import { IAccordionHeader, ITableDataRow } from '../../types';
import { getFormula } from '../../utils';

interface IProps {
  headers: IAccordionHeader[] | undefined;
}

export const getNetworthTable = (props: IProps) => {
  const { headers = [] } = props;
  const datas = [];
  const rows: ITableDataRow[] = [];
  const sf = getFormula('getNetworthTable', {
    ...props,
  });
  const years = sf.noOfYears;
  let assetV = Number(sf.totalAssets);
  let liaV = Number(sf.totalLiabilities);
  const assetG = sf.aGrow / 100;
  const liaG = sf.lGrow / 100;
  for (let i = 0; i < years; ++i) {
    const diff = assetV - liaV;
    let str: string;
    str = '₹' + Math.abs(diff).toFixed(0);
    if (diff < 0) str = '-' + str;
    const row = [
      {
        value: i + 1,
        className: 'bg-white',
      },
      {
        value: str,
        className: 'bg-white',
      },
    ];
    rows.push({
      data: row,
    });
    assetV = assetV + assetV * assetG;
    liaV = liaV + liaV * liaG;
  }
  datas.push({
    type: 'table',
    title: '',
    data: [
      {
        headers: headers,
        rows: rows,
      },
    ],
  });

  return datas;
};
